import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { translations } from "@/i18n";

const LanguageContext = createContext({
  lang: "en",
  setLang: () => {},
  t: (k) => k,
});

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "en";
    return localStorage.getItem("dv_lang") || "en";
  });

  useEffect(() => {
    try {
      localStorage.setItem("dv_lang", lang);
      document.documentElement.lang = lang;
    } catch (_) {
      // ignore storage errors
    }
  }, [lang]);

  const setLang = useCallback((next) => {
    setLangState(next === "es" ? "es" : "en");
  }, []);

  // Dotted-path lookup: t("hero.title_1") or t("testimonials.items")
  const t = useCallback(
    (path) => {
      const parts = String(path).split(".");
      let node = translations[lang];
      for (const p of parts) {
        if (node && typeof node === "object" && p in node) node = node[p];
        else return path;
      }
      return node === undefined || node === null ? path : node;
    },
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
